/**
 * FontSizeProvider - Sets CSS variables for font size based on theme fontSize
 * 
 * Applies font size multiplier to root element via CSS custom properties
 */

"use client";

import { useEffect } from "react";
import { useDashboardTheme } from "./DashboardThemeProvider";

// Font size multipliers (must match theme.ts)
const FONT_SIZE_MULTIPLIERS: Record<"small" | "medium" | "large", number> = {
  small: 0.875, // 14px base
  medium: 1,    // 16px base (default)
  large: 1.125, // 18px base
};

export const FontSizeProvider = () => {
  const { fontSize, previewFontSize } = useDashboardTheme();
  
  const effectiveFontSize = previewFontSize || fontSize;
  const multiplier = FONT_SIZE_MULTIPLIERS[effectiveFontSize];

  useEffect(() => {
    // Set CSS custom property on document root
    document.documentElement.style.setProperty(
      "--font-size-multiplier",
      multiplier.toString()
    );
    
    // Also set base font size (16px * multiplier)
    const baseFontSize = 16 * multiplier;
    document.documentElement.style.setProperty(
      "--base-font-size",
      `${baseFontSize}px`
    );
  }, [multiplier, effectiveFontSize]);

  return null;
};
